export const getEnvVar = (value, defaultValue, isValid = val => val != null) => (
  isValid(value) ? value : defaultValue
);

export const isJSON = (str) => {
  try {
      return (JSON.parse(str) && !!str);
  } catch (e) {
      return false;
  }
}

export const getEnvObj = (value, defaultValue) => (
  isJSON(value) ? JSON.parse(value) : JSON.parse(defaultValue)
);

export const getEnvFlag = (value, trueValue = true, falseValue = false) => (
  (value === 'true' || value === '1') ? trueValue : falseValue
);

export const addressLineMaxLen = 40;